import { schema } from 'normalizr';
import assetSchema from './asset_schema';

const doorSchema = new schema.Entity('doors', {
  assets: [assetSchema],
  type: new schema.Entity('door_types'),
  catalog_entries: [new schema.Entity('catalog_entries')],
});

export default doorSchema;
